// extracted by mini-css-extract-plugin
module.exports = {"tab_Name_And_Icon":"TestDataSetManagement_tab_Name_And_Icon__2nDZ2","popover_Text":"TestDataSetManagement_popover_Text__BaLNS","info_Icon":"TestDataSetManagement_info_Icon__2eUa5"};